import React from 'react';
import PropTypes from 'prop-types';
import ReactJWPlayer from 'react-jw-player';
import { JW_PLAYER_TYPE_FILE, VIDEO_WRAPPER_CLASS_NAME } from '../../../../constants';
import JWPlayerController from './JWPlayerController';

const PlayerController = new JWPlayerController();

const JWPlayerProvider = ({
  url,
  name,
  autoplay,
  controls,
  type,
  urlScript,
  muted,
  imageData,
  loop: repeat
}) => {
  const handleOnReady = () => {
    const jwPlayer = window.jwplayer(name);
    if (jwPlayer) {
      PlayerController.setPlayer(jwPlayer);
    }
  };

  const getJWPlayerProps = () => {
    const { events } = PlayerController;

    const props = {
      customProps: { repeat, controls, events },
      playerScript: urlScript,
      isAutoPlay: autoplay,
      isMuted: muted,
      playerId: name,
      onReady: handleOnReady,
      className: VIDEO_WRAPPER_CLASS_NAME
    };

    if (type === JW_PLAYER_TYPE_FILE) {
      const { url: imageURL = '' } = imageData;
      return { ...props, image: imageURL, file: url };
    }

    return { ...props, playlist: url };
  };

  return <ReactJWPlayer {...getJWPlayerProps()} />;
};

JWPlayerProvider.propTypes = {
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  urlScript: PropTypes.string.isRequired,
  imageId: PropTypes.string,
  autoplay: PropTypes.bool,
  loop: PropTypes.bool,
  controls: PropTypes.bool,
  muted: PropTypes.bool,
  type: PropTypes.string,
  imageData: PropTypes.object
};

JWPlayerProvider.defaultProps = {
  autoplay: false,
  loop: false,
  controls: true,
  muted: false,
  type: 'playlist',
  imageId: null,
  imageData: {}
};

export default JWPlayerProvider;
